export default __webpack_public_path__ + "static/media/footer-card-background-desktop.71f3693f.svg";